import { render, staticRenderFns } from "./LandTransportationForm.vue?vue&type=template&id=47c24960&scoped=true&"
import script from "./LandTransportationForm.vue?vue&type=script&lang=js&"
export * from "./LandTransportationForm.vue?vue&type=script&lang=js&"
import style1 from "./LandTransportationForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c24960",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c24960')) {
      api.createRecord('47c24960', component.options)
    } else {
      api.reload('47c24960', component.options)
    }
    module.hot.accept("./LandTransportationForm.vue?vue&type=template&id=47c24960&scoped=true&", function () {
      api.rerender('47c24960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/LandTransportation/components/LandTransportationForm.vue"
export default component.exports